import { connect } from "react-redux";

import type { ResultsReduxState } from "@app/types/results-redux-types";
import type { TripOption } from "@app/types/results-types";

import { ClassesList as ClassesListComponent } from "./classes-list";
import { getLegCardOptionsMatrixForJourney } from "../../results/selectors/leg-cards/get-options";

interface StateProps {
  trip_classes: TripOption[][];
  loading: boolean;
  is_single_class_option?: boolean;
}

interface OwnProps {
  leg_card_id: string | null;
  journey_id: string | null;
}

const mapStateToProps = (
  state: ResultsReduxState,
  ownProps: OwnProps
): StateProps => {
  const { leg_card_id, journey_id } = ownProps;

  if (!leg_card_id) {
    return { trip_classes: [], loading: true };
  }

  const trip_classes = getLegCardOptionsMatrixForJourney(
    state,
    leg_card_id,
    journey_id
  );
  const is_single_class_option = trip_classes.length === 1;

  return {
    trip_classes,
    is_single_class_option,
    loading: !trip_classes.length
  };
};

const connector = connect(mapStateToProps);

export const ClassesList = connector(ClassesListComponent);
